import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'capacityCategory' })
export class CapacityCategoryPipe implements PipeTransform {
    transform(value: CapacityCategory, ...args: any[]): any {
        // maybe sync automatically with locale-en.json?
        switch (value) {
            case 'FZK_INC':
                return 'FZKinc';
            case 'INTERRUPTIBLE':
                return 'Interruptible';
            case 'FIRM_ADDITIONAL':
                return 'Firm additional';
            case 'TVK':
                return 'TVK';
            case 'U_KC':
                return 'UKc';
            case 'BACKHAUL_CAPACITY':
                return 'Backhaul capacity';
            case 'BACKHAUL_LEVEL_2':
                return 'Backhaul level 2';
            case 'BACKHAUL_LEVEL_1':
                return 'Backhaul level 1';
            case 'BZK':
                return 'BZK';
            case 'U_BZK':
                return 'uBZK';
            case 'DZK':
                return 'DZK';
            case 'DZK_1':
                return 'DZK1';
            case 'DZK_2':
                return 'DZK2';
            case 'DZK_3':
                return 'DZK3';
            case 'DZK_4':
                return 'DZK4';
            case 'DZK_5':
                return 'DZK5';
            case 'DZK_SH':
                return 'DZK-SH';
            case 'IUKCF_1':
                return 'IUKCF1';
            case 'INCREMENTAL_OFFER_LEVEL_1':
                return 'Incremental Offer level 1';
            case 'INCREMENTAL_OFFER_LEVEL_2':
                return 'Incremental Offer level 2';
            case 'INCREMENTAL_OFFER_LEVEL_3':
                return 'Incremental Offer level 3';
            case 'INCREMENTAL_OFFER_LEVEL_4':
                return 'Incremental Offer level 4';
            case 'INCREMENTAL_OFFER_LEVEL_5':
                return 'Incremental Offer level 5';
            case 'B_FZK':
                return 'bFZK';
            case 'B_FZK_1':
                return 'bFZK1';
            case 'B_FZK_C':
                return 'bFZKc';
            case 'BACKHAUL_LEVEL_N':
                return 'Backhaul level n';
            case 'FZK':
                return 'FZK';
            case 'INTERRUPTIBLE_LEVEL_N':
                return 'Interruptible level n';
            case 'INTERRUPTIBLE_LEVEL_1':
                return 'Interruptible level 1';
            case 'FIRM':
                return 'Firm';
            case 'INTERRUPTIBLE_LEVEL_2':
                return 'Interruptible level 2';
            case 'FZK_C':
                return 'FZKc';
        }
    }
}
